import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import WithAuth from '../../../HOCs/WithAuth'
import LoadingScreen from '../../../components/LoadingScreen'

import SubmittedCharts from './SubmittedCharts'
import ValidationCharts from './ValidationCharts'

import {
  getAllSiteSubmittedCharts,
  getAllRegionCharts,
  getChartsNeedingValidation,
} from '../reducers/chartsReducer'


const TabulatedChartsListContainer = (props) => {
  const {
    routerProps,
    fetchingAllSiteSubmittedCharts,
    allSiteSubmittedCharts,
    fetchingAllRegionCharts,
    allRegionCharts,
    fetchingChartsNeedingValidation,
    chartsNeedingValidation,
  } = props

  const getContext = () => {
    const fields = {
      all: {
        loading: fetchingAllRegionCharts,
        charts: allRegionCharts,
        fetchCharts: () => props.getAllRegionCharts(props.alert),
        DisplayComponent: SubmittedCharts,
      },
      submitted: {
        loading: fetchingAllSiteSubmittedCharts,
        charts: allSiteSubmittedCharts,
        fetchCharts: () => props.getAllSiteSubmittedCharts(props.alert),
        DisplayComponent: SubmittedCharts,
      },
      validate: {
        loading: fetchingChartsNeedingValidation,
        charts: chartsNeedingValidation,
        fetchCharts: () => props.getChartsNeedingValidation(props.alert),
        DisplayComponent: ValidationCharts,
      },
    }

    return fields[props.route]
  }

  const { loading, charts, fetchCharts, DisplayComponent } = getContext()

  useEffect(fetchCharts, [])

  if (loading) {
    return <LoadingScreen text="Loading Charts" />
  } else {
    return (
      <div className='ChartsContainer'>
        <DisplayComponent
          charts={charts}
          routerProps={routerProps}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    fetchingAllSiteSubmittedCharts: state.chartsReducer.fetchingAllSiteSubmittedCharts,
    allSiteSubmittedCharts: state.chartsReducer.allSiteSubmittedCharts,
    fetchingAllRegionCharts: state.chartsReducer.fetchingAllRegionCharts,
    allRegionCharts: state.chartsReducer.allRegionCharts,
    fetchingChartsNeedingValidation: state.chartsReducer.fetchingChartsNeedingValidation,
    chartsNeedingValidation: state.chartsReducer.chartsNeedingValidation,
  }
}

const mapDispatchToProps = {
  getAllSiteSubmittedCharts,
  getAllRegionCharts,
  getChartsNeedingValidation,
}

export default WithAuth(connect(mapStateToProps, mapDispatchToProps)(TabulatedChartsListContainer))
